const INFO = {
	main: {
		title: "Portfolio - Galvin",
		name: "Galvin",
		email: "daoquanghuy2907@gmail.com",
		logo: "../logo.jpg",
	},

	socials: {
		twitter: "https://x.com/huydq_itd",
		github: "https://github.com/quanghuybrightstar",
		linkedin: "https://www.linkedin.com/in/galvin2907/",
		instagram: "https://www.instagram.com/tuilahuyday_/",
		stackoverflow: "https://stackoverflow.com/users/21915207/quang-huy",
		facebook: "https://www.facebook.com/tuilahuyday.galvin/",
	},

	homepage: {
		title: "FrontEnd web, Mobile app developer",
		description:
			"I am a frontend developer with reactJS and nextJS. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies. I enjoy solving complex problems and learning new skills. I am passionate about creating high-quality code that follows best practices and industry standards. I am always looking for new challenges and opportunities to grow as a developer.",
	},

	about: {
		title: "I’m Galvin. I live in Hanoi-Vietnam where I design the future.",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "English Mastery Hub",
			description:
				"Comprehensive support system for online English learning center: Admin, Teacher, and Student.",
			logo: "./logo_emh.png",
			linkText: "View Project",
			link: "https://github.com/vanlinh20020435/EnglishMasteryHub",
		},
		{
			title: "DashBoard",
			description:
				"Website dashboard for managing electronic products for commercial stores using management charts, categories, products, ...",
			logo: "https://cdn-icons-png.flaticon.com/512/10397/10397171.png",
			linkText: "View Project",
			link: "https://github.com/quanghuybrightstar/DashBoard",
		},
		{
			title: "Main City",
			description:
				"A world of game portals and transaction services to redeem attractive gifts awaits you.",
			logo: "https://cdn-icons-png.flaticon.com/512/2196/2196334.png",
			linkText: "View Project",
			link: "https://github.com/quanghuybrightstar/main_city",
		},

		{
			title: "Monopoly Game",
			description:
				"A game developed based on the legendary monopoly game with dice rotation, items and attractive rewards, ... built with Phaser 3.",
			logo: "./logo_monopoly.png",
			linkText: "View Project",
			link: "https://github.com/quanghuybrightstar/MonopolyGame",
		},

		{
			title: "Racing Game",
			description:
				"A car racing game that overcomes obstacles and other cars, accompanied by attractive items and rewards, ... built with Phaser 3.",
			logo: "https://cdn-icons-png.flaticon.com/512/3907/3907054.png",
			linkText: "View Project",
			link: "https://github.com/quanghuybrightstar/RacingGame",
		},
	],

	works: [
		{
			id: 1,
			name: "Kaopiz",
			subtitle: "Software Engineer",
			startDate: "04/2025",
			endDate: "Present",
			srcLogo:
				"./kaopiz.jpg",
		},
		{
			id: 2,
			name: "VNTravel Group",
			subtitle: "FrontEnd Developer",
			startDate: "04/2024",
			endDate: "04/2025",
			srcLogo:
				"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRElheAZOQ8RIb6qt6rAn6Dkyh83w0RDAByxA&s",
		},
		{
			id: 3,
			name: "GK Corp",
			subtitle: "Web & Mobile Developer",
			startDate: "01/2023",
			endDate: "04/2024",
			srcLogo: "./gk_corp.png",
		},
	],
};

export default INFO;
